import { FC } from 'react';

import { SpheraModal } from '@sphera-cloud/component-ui-reactjs';
import { useAppSelector } from '../../hooks';
import { infoSelector } from '../../store/slices/info';

import './styles.scss';

interface Props {
  onClose: () => void;
}

const BASIC_WIDTH = 400;
const BASIC_HEIGHT = 250;

const VersionInfo: FC<Props> = ({ onClose }) => {
  const info = useAppSelector(infoSelector);

  return (
    <SpheraModal
      title="About"
      height={BASIC_HEIGHT}
      width={BASIC_WIDTH}
      onClose={onClose}
      actionText=""
      onCancel={onClose}
      noFooter
    >
      <div className="version-details">
        <div className="version-details--list-item">
          <p className="version-details--item-title">Product Name:</p>
          <p className="version-details--item-value">{info.productName}</p>
        </div>

        <div className="version-details--list-item">
          <p className="version-details--item-title">Product Version:</p>
          <p className="version-details--item-value">{info.productVersion}</p>
        </div>

        <div className="version-details--list-item">
          <p className="version-details--item-title">Api Version:</p>
          <p className="version-details--item-value">{info.apiVersion}</p>
        </div>
      </div>
    </SpheraModal>
  );
};

export default VersionInfo;
